if (!customElements.get('modern-zoom')) {
    class ModernZoom extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
            this.zoomLevel = 2.5;
            this.img = null;
            this.zoomImg = null;
        }

        connectedCallback() {
            // Only active on devices that support hover (desktop primarily)
            if (window.matchMedia('(hover: hover)').matches) {
                this.render();
                this.initEvents();
            }
        }

        render() {
            if (!this.shadowRoot) return;
            this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
            overflow: hidden;
            position: relative;
            cursor: zoom-in;
            width: 100%;
            height: 100%;
          }
          
          .zoomed-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: opacity 0.2s ease;
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            transform-origin: center center;
            will-change: transform;
            z-index: 10;
          }

          ::slotted(img), ::slotted(svg) {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        </style>
        <slot></slot>
      `;
        }

        initEvents() {
            this.img = this.querySelector('img') || this.querySelector('model-viewer') || this.querySelector('video');
            if (!this.img) return;

            this.addEventListener('mousemove', (e) => this.handleMouseMove(e));
            this.addEventListener('mouseenter', () => this.handleMouseEnter());
            this.addEventListener('mouseleave', () => this.handleMouseLeave());
        }

        handleMouseEnter() {
            if (!this.img || !this.shadowRoot) return;

            // Only zoom images for now
            if (this.img.tagName === 'IMG') {
                this.zoomImg = new Image();
                this.zoomImg.src = /** @type {HTMLImageElement} */ (this.img).currentSrc || /** @type {HTMLImageElement} */ (this.img).src;
                this.zoomImg.classList.add('zoomed-image');
                this.shadowRoot.appendChild(this.zoomImg);

                // Force layout flush logic
                void this.zoomImg.offsetHeight;
                this.zoomImg.style.opacity = '1';
            }
        }

        /**
         * @param {MouseEvent} e 
         */
        handleMouseMove(e) {
            if (!this.zoomImg) return;

            const rect = this.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            // Calculate percentage position
            const xPercent = (x / rect.width) * 100;
            const yPercent = (y / rect.height) * 100;

            this.zoomImg.style.transformOrigin = `${xPercent}% ${yPercent}%`;
            this.zoomImg.style.transform = `scale(${this.zoomLevel})`;
        }

        handleMouseLeave() {
            if (this.zoomImg) {
                this.zoomImg.style.opacity = '0';
                const imgToRemove = this.zoomImg;
                this.zoomImg = null;

                setTimeout(() => {
                    if (imgToRemove && imgToRemove.parentNode) {
                        imgToRemove.remove();
                    }
                }, 200);
            }
        }
    }

    customElements.define('modern-zoom', ModernZoom);
}
